<template>
  <div>
    <b-modal
      id="success-modal"
      ref="modal"
      title=""
      hide-footer
      hide-header
      centered
    >
      <div class="header">
        <span class="close-icon"
              @click="$bvModal.hide('success-modal')">
          <img src="@/assets/svg/close.svg"
               aria-label="close">
        </span>

        <h3>
          Поздравляем! <br/> Вы успешно зарегистрировались!
        </h3>

        <div class="text">
          Ваш пароль для входа был отправлен на электронную почту, указанную при регистрации.
        </div>
      </div>

      <b-button class="button button-gold"
                @click="openModal">Войти</b-button>
    </b-modal>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },

    methods: {
      openModal(){
        this.$bvModal.hide('success-modal')
        this.$bvModal.show('login-modal')
      }
    }
  }
</script>

<style scoped lang="scss">
.header {
  flex-direction: column;
  width: 100%;

  .close-icon {
    float: right;
    cursor: pointer;
    transition: .4s all;
    margin-right: 5px;

    &:hover {
      opacity: .85;
    }
  }

  h3 {
    width: 100%;
    margin-top: 50px;
    margin-bottom: 20px;
    font-weight: 800;
    font-family: $regular;
    font-size: 18px;
    text-transform: uppercase;
    text-align: center;
    color: white;
  }
}

.text {
  font-size: 18px;
  text-align: left;
  font-family: $regular;
  margin-bottom: 40px;
  color: white;
  margin-top: 20px;
}

.button-gold {
  width: 100%;
  max-width: 300px;
}
</style>
